import { sharedSchema } from "@shared-database/pgSchema";

import { leoEnum, timestampColumns } from "@shared-database/utils";
import { text, timestamp, index } from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import type { z } from "zod";
import { User } from "./user";

export const AuthProviderIdEnumValues = [
  "azure-ad",
  "microsoft-sso",
  "agent",
] as const;

export type AuthProviderIdEnum = (typeof AuthProviderIdEnumValues)[number];

export const ProviderIdEnum = leoEnum(
  "AuthProviderId",
  AuthProviderIdEnumValues,
);

export const Session = sharedSchema.table(
  "Session",
  {
    // Mixins
    ...timestampColumns,

    // Properties
    sessionToken: text("sessionToken").notNull().primaryKey(),
    userId: text("userId")
      .notNull()
      .references(() => User.id, { onDelete: "cascade" }),
    expires: timestamp("expires", { mode: "date" }).notNull(),
    providerId: ProviderIdEnum("providerId").default("azure-ad").notNull(),
  },
  (table) => [
    index("Session_userIdIdx").on(table.userId),
    index("Session_sessionTokenIdx").on(table.sessionToken),
  ],
);
export const insertSessionSchema = createInsertSchema(Session);
export type InsertSessionType = z.infer<typeof insertSessionSchema>;
